export default __webpack_public_path__ + "static/media/chat-red.af328386.svg";